<template>
<!--    来料入库表-->
    <div class="wf">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <div class="formDiv">

                <div class="item">
                    <el-form-item class="form-title" prop="gsname" :label="$t('promanagement_processing_unit')" >
                        <el-select v-model="formData.gsname" placeholder="请选择加工单位" @change="changeCompany" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="item in companyName"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="bmname" :label="$t('promanagement_processing_department')" >
                        <el-select v-model="formData.bmname" placeholder="请选择加工部门" @change="changeGroup" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="itembm in groupName"
                                    :key="itembm.i_id"
                                    :label="itembm.vc_name"
                                    :value="itembm.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{itembm.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="sqName" label="申请人" >
                        <el-select v-model="formData.sqName" :placeholder="$t('form_please_select_the_applicant')" @change="changePerson" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="itemsq in personName"
                                    :key="itemsq.i_id"
                                    :label="itemsq.vc_name"
                                    :value="itemsq.i_id">
                                <!--                                <span style="display: inline-block;width: 100%">{{itemsq.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title num" prop="num" label="No:" >
                        <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                    </el-form-item>
                </div>
                <div class="item">
                    <el-form-item class="form-title" prop="wtname" :label="$t('form_entrust_company')" >
                        <el-select v-model="formData.wtname" placeholder="请选择委托公司" disabled>
                            <el-option
                                    v-for="item in wtgsList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="wtnum" label="委托单号" >
                        <el-select v-model="formData.wtnum" placeholder="请选择委托单号" @change="changewtnum" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="one in wtnumList"
                                    :key="one.i_id"
                                    :label="one.vc_name"
                                    :value="one.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="ckname" label="入库仓库" >
                        <el-select v-model="formData.ckname" placeholder="请选择入库仓库" @change="changeWarehouse" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="one in warehouseName"
                                    :key="one.i_id"
                                    :label="one.vc_name"
                                    :value="one.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>

                </div>


            </div>
            <div style="margin-bottom: 20px">
                <el-table
                        border
                        size="mini"
                        ref="multipleTable"
                        :data="tableData"
                        height="441"
                        tooltip-effect="dark"
                        style="width: 100%;">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <!--<el-table-column
                            align="left"
                            prop="vc_gsname"
                            label="公司"
                            width="200"
                            show-overflow-tooltip>
                    </el-table-column>-->
                    <el-table-column
                            align="left"
                            prop="vc_pmname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <!--<el-table-column
                            align="left"
                            prop="vc_no"
                            label="批次号"
                    width="200"
                            show-overflow-tooltip>
                    </el-table-column>-->
                    <!--<el-table-column
                            align="left"
                            prop="kysl"
                            label="可用库存"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>-->
                    <el-table-column
                            align="left"
                            prop="f_num"
                            label="申请入库数量"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_no"
                            label="库号"
                            width="250"
                            show-overflow-tooltip>
                    </el-table-column>
                </el-table>
            </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                <el-input  v-model="formData.vc_note" :disabled="edit">
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_date')" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" v-if="edit==false" class="dialog-footer" style="text-align: center">

            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'">保存</el-button>
            <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
<!--            <el-button type="primary" @click="toApprove" v-if="state==0" :disabled="disabled">提交审批</el-button>-->
            <!--<el-button type="primary" @click="" :disabled="disabled">作废</el-button>
            <el-button type="primary" @click="" :disabled="disabled">中止</el-button>-->
        </div>
    </div>
</template>

<script>
    import * as API from "./../api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "WarehouseForm",
        props:{
            warehouse:{
                type:Object,
                required:true

            }
        },
        data() {
            return {
                edit:false,
                gsname:"",
                bmname:"",
                sqName:"",
                wtname:"",
                wtnum:"",
                ckname:"",
                formData:{
                    gsname:"",
                    bmname:"",
                    sqName:"",
                    wtname:"",
                    wtnum:"",
                    ckname:"",
                    num:"000000",
                    vc_note:"",
                    vc_lruname: sessionStorage.getItem("lruname"),
                    date:"",
                    tableData:[],

                },
                formRules:{
                    gsname:[{required:true,message:"请选择公司",trigger:"change"}],
                    bmname:[{required:true,message:"请选择部门",trigger:"change"}],
                    sqName:[{required:true,message:"请填写申请人",trigger:"change"}],
                    ckname:[{required:true,message:"请选择仓库",trigger:"change"}],
                    wtnum:[{required:true,message:"请选择委托单号",trigger:"change"}],
                },
                companyName:[],
                groupName:[],
                personName:[],
                wtgsList:[],
                wtnumList:[],
                warehouseName:[],
                tableData:[],
                wtnumid:0,
                squid:0,
                wtgsid:0,
                wtgsname:"",
                disabled:false,
                baseerp:"",
                formid:0,
                mid:0,
            }
        },
        mounted() {
            //console.log(this.warehouse)
            this.baseerp=baseerp;
            this.wtgsname=this.warehouse.vc_name;
            this.formData.wtname=this.warehouse.vc_name;
            this.formid=this.warehouse.pid;
            this.mid=this.warehouse.i_mid;
            this.wtgsid=this.warehouse.i_id;
            if (this.formid==0){
                this.edit=false;
                this.getCompanyList();
                this.getGroupList();
                this.getWarehouseList();
                this.getEntrustOddNumList();
                this.getDateYYYYMMdd();
            }else {
                this.edit=true;
                this.getIncomingMaterial();
            }
        },
        methods: {
            async getIncomingMaterial(){
                let param={
                    i_mid: this.mid,
                    i_id:this.formid,
                };
                let res=await API.getIncomingMaterial(param);
                if(res.code==1){
                    let data=res.data;
                    this.formData={
                        gsname:data.vc_outgsname,
                        bmname:data.vc_outgname,
                        sqName:data.vc_squname,
                        wtname:data.vc_ingsname,
                        wtnum:data.vc_oddNum,
                        ckname:data.vc_inckname,
                        num:data.i_id,
                        vc_note:data.vc_note,
                        vc_lruname:data.vc_lruname,
                        date:data.dt_createtime,
                        tableData:data.product,
                    }
                    this.tableData=data.product;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_mid: this.mid,
                    i_type: "2",
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    this.companyName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getGroupList(val){
                let param={
                    i_mid: this.mid,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.groupName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getPersonList(groupid){
                let param={
                    i_groupid:groupid,
                };
                let res=await API.getPersonList(param);
                if(res.code==1){
                    this.personName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getWarehouseList(){
                let param={
                    i_mid: this.mid,
                };
                let res=await API.getWarehouseList(param);
                if(res.code==1){
                    this.warehouseName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getEntrustOddNumList(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.wtgsid,
                };
                let res=await API.getEntrustOddNumList(param);
                if(res.code==1){
                    this.wtnumList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getEntrustOddNumHaveList(wtnumid){
                let param={
                    i_mid: this.mid,
                    i_id:wtnumid,
                };
                let res=await API.getEntrustOddNumHaveList(param);
                if(res.code==1){
                    this.formData.tableData=res.data;
                    this.tableData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            changeCompany(val){
                //console.log("--gsis",val)
                this.gsid=val;
                this.formData.sqName='';
                if (val??''!==''){
                    this.getGroupList(val);
                }

            },
            changeGroup(groupid){
                //console.log(groupid,"======")
                this.formData.sqName='';
                this.squid='';
                this.sqName='',
                    this.gid=groupid;
                if (groupid??''!==''){
                    this.getPersonList(groupid);
                }

            },
            changePerson(perid){
                if (perid??''!=='') {
                    this.squid = perid;
                    let obj = this.personName.find(item => item.i_id == perid);
                    this.sqName = obj.vc_name;
                }
            },
            changeWarehouse(val){
                //console.log("--ckis",val)
                this.ckid=val;
            },
            changewtnum(wtnumid){
                //console.log()
                this.wtnumid=wtnumid;
                this.formData.tableData=[],
                this.getEntrustOddNumHaveList(wtnumid);
            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getEntrustCompanyHaveList')
            },
            //保存
            async saveForm(){
                if (this.squid==''){
                    this.$message.error("请填写申请人");
                    return
                }
                if (this.wtnumid==''){
                    this.$message.error("请添加产品");
                    return
                }
                //console.log(this.tableData,"------")
                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                    i_outgsid:this.gsid,
                    i_ingsid:this.wtgsid,
                    i_outgid:this.gid,
                    i_inckid:this.ckid,
                    i_squid:this.squid,
                    vc_squname:this.sqName,
                    vc_note:this.formData.vc_note,
                    i_pid:this.wtnumid,
                    //i_lruid:this.i_lruid,
                    // i_lruid:42,
                    // vc_lruname:" zyh",
                    // vc_lruname:this.formData.vc_lruname,
                    product:this.formData.tableData,
                };
                let res=await API.saveIncomingMaterial(param);
                if(res.code==1){
                    this.$emit('getEntrustCompanyHaveList',this.wtgsid)
                    this.$message.success(res.message);
                    this.disabled=true;

                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMdd(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    /deep/{
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }

    }

</style>